/**
 * @link https://span.studio
 * @copyright Copyright (c) Span Studio LLC
 * @license https://github.com/Span-Studio/sta100-craft5/blob/main/LICENSE.md
 * 
 * AutoCompleteField
 * A text field that autocompletes against a set of options.
 * Used within forms.
 * 
 * @author John Pobojewski <https://john.pobojewski.com>
 * @link https://www.w3schools.com/howto/howto_js_autocomplete.asp
 */

class AutoCompleteField {
	constructor() {}

	init() {
		console.log("AutoCompleteField.init()");

		let studioObj = document.getElementById("studio-list").innerHTML;
		let field = document.getElementsByClassName("autocomplete-field-container")[0];
		let dataField = document.getElementsByClassName("autocomplete-field-data")[0];

		let data = JSON.parse(studioObj);
		let currentFocus;

		field.addEventListener("input", function(e) {
			var a, b, i, val = this.value;
			closeAllLists();
			if (!val) { return false;}
			currentFocus = -1;
			a = document.createElement("DIV");
			a.setAttribute("id", this.id + "autocomplete-list");
			a.setAttribute("class", "autocomplete-items");
			this.parentNode.appendChild(a);

			for (i = 0; i < data.length; i++) {
				let name = data[i]["name"];
				let id = data[i]["id"];

				if (name.substr(0, val.length).toUpperCase() == val.toUpperCase()) {
					b = document.createElement("DIV");
					b.innerHTML = "<strong>" + name.substr(0, val.length) + "</strong>";
					b.innerHTML += name.substr(val.length);
					b.innerHTML += "<input data-id='" + id + "' type='hidden' value='" + name + "'>";
					b.addEventListener("click", function(e) {
						field.value = this.getElementsByTagName("input")[0].value;
						let dataContainer = document.getElementsByClassName("autocomplete-field-data")[0];
						dataContainer.value = this.getElementsByTagName("input")[0].getAttribute("data-id");
						closeAllLists();
					});
					a.appendChild(b);
				}
			}
		});

		/*execute a function presses a key on the keyboard:*/
		field.addEventListener("keydown", function(e) {
			var x = document.getElementById(this.id + "autocomplete-list");
			if (x) x = x.getElementsByTagName("div");
			if (e.keyCode == 40) {
				currentFocus++;
				addActive(x);
			} else if (e.keyCode == 38) { //up
				currentFocus--;
				addActive(x);
			} else if (e.keyCode == 13) {
				e.preventDefault();
				if (currentFocus > -1) {
					if (x) x[currentFocus].click();
				}
			}
		});

		function addActive(x) {
			if (!x) return false;
			removeActive(x);
			if (currentFocus >= x.length) currentFocus = 0;
			if (currentFocus < 0) currentFocus = (x.length - 1);
			x[currentFocus].classList.add("autocomplete-active");
		}

		function removeActive(x) {
			for (var i = 0; i < x.length; i++) {
				x[i].classList.remove("autocomplete-active");
			}
		}

		function closeAllLists(elmnt) {
			var x = document.getElementsByClassName("autocomplete-items");
			for (var i = 0; i < x.length; i++) {
				if (elmnt != x[i] && elmnt != field) {
					x[i].parentNode.removeChild(x[i]);
				}
			}
		}

		/*execute a function when someone clicks in the document:*/
		document.addEventListener("click", function (e) {
			closeAllLists(e.target);
		});
	}
}

export default new AutoCompleteField();
